// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"BeaconItem_checkbox__zHTgq","icon":"BeaconItem_icon__HGR-G"};